"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 0;
var MIDDLE = exports.MIDDLE = 1;
var RIGHT = exports.RIGHT = 2;
var BACK = exports.BACK = 3;
var FORWARD = exports.FORWARD = 4;